export default __webpack_public_path__ + "static/media/minus.f0d95df5.png";